import * as React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import HomeUnlinkedApplicationPolicyHolder from "./policy-holder";
import UnlinkedApplicationHomeBundleAutoRoute from "./bundle-auto";
import UnlinkedApplicationHomeownersApplicableDiscounts from "./applicable-discounts";
import UnlinkedApplicationHomeownersIntro from "./intro";
import UnlinkedApplicationHomeownersMilitaryPage from "./military";
import UnlinkedApplicationHomeownersPropertyAddress from "./property-address";
import UnlinkedApplicationHomeownersSquareFootage from "./square-footage";
import UnlinkedApplicationHomeownersYearBuilt from "./year-built";
import UnlinkedHomeownersPremium from "./premium";
export default function UnlinkedApplicationHomeownersRoutes() {
    var path = useRouteMatch().path;
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: "".concat(path, "/intro") },
            React.createElement(UnlinkedApplicationHomeownersIntro, null)),
        React.createElement(Route, { path: "".concat(path, "/policy-holder") },
            React.createElement(HomeUnlinkedApplicationPolicyHolder, null)),
        React.createElement(Route, { path: "".concat(path, "/applicable-discounts") },
            React.createElement(UnlinkedApplicationHomeownersApplicableDiscounts, null)),
        React.createElement(Route, { path: "".concat(path, "/property-address") },
            React.createElement(UnlinkedApplicationHomeownersPropertyAddress, null)),
        React.createElement(Route, { path: "".concat(path, "/square-footage") },
            React.createElement(UnlinkedApplicationHomeownersSquareFootage, null)),
        React.createElement(Route, { path: "".concat(path, "/year-built") },
            React.createElement(UnlinkedApplicationHomeownersYearBuilt, null)),
        React.createElement(Route, { path: "".concat(path, "/premium") },
            React.createElement(UnlinkedHomeownersPremium, null)),
        React.createElement(Route, { path: "".concat(path, "/bundle-auto") },
            React.createElement(UnlinkedApplicationHomeBundleAutoRoute, null)),
        React.createElement(Route, { path: "".concat(path, "/military") },
            React.createElement(UnlinkedApplicationHomeownersMilitaryPage, null))));
}
